export default {
    send: 'Toujours envoyer',
    dontSend: 'Ne pas exécuter si fermé',
    nextOpen: "Exécuter à l'ouverture",
    weekdays: 'Seulement les journées choisies',
};
